import { gql } from "@apollo/client";

export const BANNER_FIELDS = gql`
  fragment BannerFields on Banner {
    id
    tenantId
    tenant {
      id
      name
      slug
    }
    subaccountId
    subaccount {
      id
      name
      slug
    }
    userEmail
    level
    message
    link
    linkText
    startsAt
    expiresAt
    createdByEmail
    createdAt
    updatedAt
  }
`;

export const LIST_ACTIVE_BANNERS_FOR_TENANT = gql`
  ${BANNER_FIELDS}
  query listActiveBannersForTenant {
    listActiveBannersForTenant {
      ...BannerFields
    }
  }
`;

export const LIST_ACTIVE_BANNERS_FOR_SUBACCOUNT = gql`
  ${BANNER_FIELDS}
  query listActiveBannersForSubaccount(
    $input: ListActiveBannersForSubaccountInput!
  ) {
    listActiveBannersForSubaccount(input: $input) {
      ...BannerFields
    }
  }
`;

export const LIST_ALL_BANNERS = gql`
  ${BANNER_FIELDS}
  query listAllBanners($input: ListAllBannersInput!) {
    listAllBanners(input: $input) {
      ...BannerFields
    }
  }
`;

export const ADD_BANNER = gql`
  ${BANNER_FIELDS}
  mutation addBanner($input: AddBannerInput!) {
    addBanner(input: $input) {
      ...BannerFields
    }
  }
`;

export const UPDATE_BANNER = gql`
  ${BANNER_FIELDS}
  mutation updateBanner($input: UpdateBannerInput!) {
    updateBanner(input: $input) {
      ...BannerFields
    }
  }
`;
